import { stringFromMinutes } from '@app/helpers/timeFormat';

export enum AvailableType {
  PickUpNow = 1,
  PickUpInTwoHours,
  PickUpTomorrow,
  PickUpTheDayAfterTomorrow,
  PickUpInThreeDays,
  OnOrderFromFiveDays,
  NoInfo,
  PickUpInTwoDays,
  PickupInFourDays,
  PickupInNDays, // n - day
  OnOrderFromSixDays,
  OnOrderFromSevenDays,
  OnOrderFromEightDays,
  OnOrderFromNineDays,
  PickupInXDays,
  PickupInXIDays,
  PickupInXIIDays,
  PickupInXIIIDays,
  PickupInXIVDays,
  PickupInXVDays,
}

export const takeAfterXMinutes = (minutes: number): string => {
  return minutes === 0 ? 'сейчас' : `через ${stringFromMinutes(minutes)}`;
};

export const AvailableString = {
  [AvailableType.PickUpNow]: 'Забрать сейчас',
  [AvailableType.PickUpInTwoHours]: 'Забрать через 2 часа',
  [AvailableType.PickUpTomorrow]: 'Забрать завтра',
  [AvailableType.PickUpTheDayAfterTomorrow]: 'Забрать послезавтра',
  [AvailableType.PickUpInTwoDays]: 'Забрать через 2 дня',
  [AvailableType.PickUpInThreeDays]: 'Забрать через 3 дня',
  [AvailableType.PickupInFourDays]: 'Забрать через 4 дня',
  [AvailableType.OnOrderFromFiveDays]: 'Под заказ от 5 дней',
  [AvailableType.OnOrderFromSixDays]: 'Под заказ от 6 дней',
  [AvailableType.OnOrderFromSevenDays]: 'Под заказ от 7 дней',
  [AvailableType.OnOrderFromEightDays]: 'Под заказ от 8 дней',
  [AvailableType.OnOrderFromNineDays]: 'Под заказ от 9 дней',
  [AvailableType.PickupInXDays]: 'Под заказ от 10 дней',
  [AvailableType.PickupInXIDays]: 'Под заказ от 11 дней',
  [AvailableType.PickupInXIIDays]: 'Под заказ от 12 дней',
  [AvailableType.PickupInXIIIDays]: 'Под заказ от 13 дней',
  [AvailableType.PickupInXIVDays]: 'Под заказ от 14 дней',
  [AvailableType.PickupInXVDays]: 'Под заказ от 15 дней',
  [AvailableType.NoInfo]: 'Сроки уточняйте',
};

export const AvailableStringByCartProduct = {
  [AvailableType.PickUpNow]: 'сейчас',
  [AvailableType.PickUpInTwoHours]: 'через 2 часа',
  [AvailableType.PickUpTomorrow]: 'завтра',
  [AvailableType.PickUpTheDayAfterTomorrow]: 'послезавтра',
  [AvailableType.PickUpInTwoDays]: 'через 2 дня',
  [AvailableType.PickUpInThreeDays]: 'через 3 дня',
  [AvailableType.PickupInFourDays]: 'через 4 дня',
  [AvailableType.OnOrderFromFiveDays]: 'от 5 дней',
  [AvailableType.OnOrderFromSixDays]: 'от 6 дней',
  [AvailableType.OnOrderFromSevenDays]: 'от 7 дней',
  [AvailableType.OnOrderFromEightDays]: 'от 8 дней',
  [AvailableType.OnOrderFromNineDays]: 'от 9 дней',
  [AvailableType.PickupInXDays]: 'от 10 дней',
  [AvailableType.PickupInXIDays]: 'от 11 дней',
  [AvailableType.PickupInXIIDays]: 'от 12 дней',
  [AvailableType.PickupInXIIIDays]: 'от 13 дней',
  [AvailableType.PickupInXIVDays]: 'от 14 дней',
  [AvailableType.PickupInXVDays]: 'от 15 дней',
  [AvailableType.NoInfo]: 'Нет в наличии',
};

export const AvailableStringProductRow = {
  [AvailableType.PickUpNow]: 'сегодня',
  [AvailableType.PickUpInTwoHours]: 'сегодня',
  [AvailableType.PickUpTomorrow]: 'завтра',
  [AvailableType.PickUpTheDayAfterTomorrow]: 'послезавтра',
  [AvailableType.PickUpInTwoDays]: 'через 2 дня',
  [AvailableType.PickUpInThreeDays]: 'через 3 дня',
  [AvailableType.PickupInFourDays]: 'через 4 дня',
  [AvailableType.OnOrderFromFiveDays]: 'от 5 дней',
  [AvailableType.OnOrderFromSixDays]: 'от 6 дней',
  [AvailableType.OnOrderFromSevenDays]: 'от 7 дней',
  [AvailableType.OnOrderFromEightDays]: 'от 8 дней',
  [AvailableType.OnOrderFromNineDays]: 'от 9 дней',
  [AvailableType.PickupInXDays]: 'от 10 дней',
  [AvailableType.PickupInXIDays]: 'от 11 дней',
  [AvailableType.PickupInXIIDays]: 'от 12 дней',
  [AvailableType.PickupInXIIIDays]: 'от 13 дней',
  [AvailableType.PickupInXIVDays]: 'от 14 дней',
  [AvailableType.PickupInXVDays]: 'от 15 дней',
  [AvailableType.NoInfo]: 'сроки уточняйте',
};

export const AvailableStringCatalogProductRow = {
  [AvailableType.PickUpNow]: 'сегодня',
  [AvailableType.PickUpInTwoHours]: 'сегодня',
  [AvailableType.PickUpTomorrow]: 'завтра',
  [AvailableType.PickUpTheDayAfterTomorrow]: 'послезавтра',
  [AvailableType.PickUpInTwoDays]: 'через 2 дня',
  [AvailableType.PickUpInThreeDays]: 'через 3 дня',
  [AvailableType.PickupInFourDays]: 'через 4 дня',
  [AvailableType.OnOrderFromFiveDays]: 'через 5 дней',
  [AvailableType.OnOrderFromSixDays]: 'через 6 дней',
  [AvailableType.OnOrderFromSevenDays]: 'через 7 дней',
  [AvailableType.OnOrderFromEightDays]: 'через 8 дней',
  [AvailableType.OnOrderFromNineDays]: 'через 9 дней',
  [AvailableType.PickupInXDays]: 'через 10 дней',
  [AvailableType.PickupInXIDays]: 'через 11 дней',
  [AvailableType.PickupInXIIDays]: 'через 12 дней',
  [AvailableType.PickupInXIIIDays]: 'через 13 дней',
  [AvailableType.PickupInXIVDays]: 'через 14 дней',
  [AvailableType.PickupInXVDays]: 'через 15 дней',
  [AvailableType.NoInfo]: 'сроки уточняйте',
};

export const AvailableStringOrderFromStock = {
  [AvailableType.PickUpInTwoDays]: 'От 2 дней',
  [AvailableType.PickUpInThreeDays]: 'От 3 дней',
  [AvailableType.PickupInFourDays]: 'От 4 дней',
  [AvailableType.OnOrderFromFiveDays]: 'От 5 дней',
  [AvailableType.OnOrderFromSixDays]: 'От 6 дней',
  [AvailableType.OnOrderFromSevenDays]: 'От 7 дней',
  [AvailableType.OnOrderFromEightDays]: 'От 8 дней',
  [AvailableType.OnOrderFromNineDays]: 'От 9 дней',
  [AvailableType.PickupInXDays]: 'От 10 дней',
  [AvailableType.PickupInXIDays]: 'От 11 дней',
  [AvailableType.PickupInXIIDays]: 'От 12 дней',
  [AvailableType.PickupInXIIIDays]: 'От 13 дней',
  [AvailableType.PickupInXIVDays]: 'От 14 дней',
  [AvailableType.PickupInXVDays]: 'От 15 дней',
  [AvailableType.NoInfo]: 'Сроки уточняйте',
};

export const stepOrder: { [index: number]: string } = {
  1: 'delivery',
  2: 'contacts',
  3: 'payment',
};

export const results: { [index: number]: string } = {
  1: 'stepDelivery',
  2: 'stepContacts',
  3: 'stepPayment',
};

export const titleDelivery: { [index: string]: string } = {
  'samovyvoz-iz-sinnogo-centra': 'Получение в центре',
  'dostavka-kurerom': 'Доставка курьером',
  'dostavka-transportnoi-kompaniei': 'Доставка транспортной компанией',
};

export enum DeliveryType {
  CourierDelivery = 'dostavka-kurerom',
  Pickup = 'samovyvoz-iz-sinnogo-centra',
  TK = 'dostavka-transportnoi-kompaniei',
}

export enum DeliveryTypeProduct {
  'Today' = 1,
  'NotToday' = 2,
}
